import { ISwapTracker } from "../../models/index";

export interface ISwapTrackerState {
    list: ISwapTracker[];
}
